module.exports = __webpack_public_path__ + "img/fail.0ffac2ac.png";